var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGadgets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "solid",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m240 368v8a24.028 24.028 0 0 1 -24 24h24a16 16 0 0 0 0-32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m32 296h32v48h-32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m40 264h16v16h-16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m128 416a31.8 31.8 0 0 1 -16-4.305v52.392a15.932 15.932 0 0 0 15.913 15.913h112.174a15.932 15.932 0 0 0 15.913-15.913v-52.387a31.8 31.8 0 0 1 -16 4.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m192 376v-8h-16v32h40a24.028 24.028 0 0 1 -24-24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m56 416v-56h-16v64.451a15.568 15.568 0 0 0 15.549 15.549h40.451v-16h-32a8 8 0 0 1 -8-8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m360 144h32v48h-32z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m384 56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v200h16v-209.479a14.539 14.539 0 0 0 -14.521-14.521h-66.958a14.539 14.539 0 0 0 -14.521 14.521v81.479h16z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m368 208h16v16h-16z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m129.889 336h6.111a8 8 0 0 1 8 8v56h16v-84.687a19.314 19.314 0 0 0 -19.313-19.313h-10.8a20.818 20.818 0 0 0 -17.887 10.048v19.9a20.818 20.818 0 0 0 17.889 10.052z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m128 400v-32a16 16 0 0 0 0 32z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m238.111 280h-10.8a19.314 19.314 0 0 0 -19.311 19.313v76.687a8 8 0 0 0 16 0v-48a8 8 0 0 1 8-8h6.111a20.818 20.818 0 0 0 17.889-10.048v-19.9a20.818 20.818 0 0 0 -17.889-10.052z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m476.625 272h-121.25a3.379 3.379 0 0 0 -3.375 3.375v25.834a2.794 2.794 0 0 0 2.791 2.791h122.418a2.794 2.794 0 0 0 2.791-2.791v-25.834a3.379 3.379 0 0 0 -3.375-3.375zm-84.625 24h-24v-16h24zm72 0h-24v-16h24z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m400 396.9 32-10.667v-2.233h-32z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m354.791 320a18.744 18.744 0 0 1 -2.791-.231v156.856a3.379 3.379 0 0 0 3.375 3.375h121.25a3.379 3.379 0 0 0 3.375-3.375v-156.856a18.744 18.744 0 0 1 -2.791.231zm93.209 136a8 8 0 0 1 -8 8h-48a8 8 0 0 1 -8-8v-80a8 8 0 0 1 8-8v-24a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8v24a8 8 0 0 1 8 8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m272 424h64v16h-64z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m408 352h16v16h-16z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m400 428.9 32-10.667v-15.133l-32 10.667z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m400 448h32v-12.9l-32 10.667z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m184 32h32v16h-32z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m152.331 160h95.338a16.349 16.349 0 0 0 16.331-16.331v-63.338a16.349 16.349 0 0 0 -16.331-16.331h-95.338a16.349 16.349 0 0 0 -16.331 16.331v63.338a16.349 16.349 0 0 0 16.331 16.331zm42.012-53.657 24-24 11.314 11.314-18.344 18.343 26.344 26.343-11.314 11.314-32-32a8 8 0 0 1 0-11.314z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m120 83.885a84.165 84.165 0 0 1 -25.889 4.115h-50.939a3.176 3.176 0 0 0 -3.172 3.172v41.656a3.176 3.176 0 0 0 3.172 3.172h50.939a84.165 84.165 0 0 1 25.889 4.115z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m310.8 88h-4.91a84.165 84.165 0 0 1 -25.89-4.115v56.23a84.165 84.165 0 0 1 25.889-4.115h4.91a1.2 1.2 0 0 0 1.2-1.2v-45.6a1.2 1.2 0 0 0 -1.199-1.2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m247.669 176h-116.356l-11.313 11.313v41.374l11.313 11.313h137.374l11.313-11.313v-41.374l-11.313-11.313zm-71.669 40h-16v-16h16zm32 0h-16v-16h16zm32 0h-16v-16h16z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGadgets);
export default __webpack_public_path__ + "static/media/Gadgets.5aad7c13.svg";
export { ForwardRef as ReactComponent };